import { useShowRangeCalendarStore } from 'src/hooks/stores'

export const useShowRangeCalendar = () => {
  const { showRangeCalendarStoreValue, setShowRangeCalendarStoreValue } =
    useShowRangeCalendarStore()
  const updateShowRangeCalendar = (newValue: boolean) => {
    setShowRangeCalendarStoreValue(newValue)
  }

  return {
    showRangeCalendar: showRangeCalendarStoreValue,
    updateShowRangeCalendar,
  }
}
